import { AppUtils } from './../../utils/app.utils';
import { ConfigService } from '@services/webFeeder/config.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild, ViewContainerRef, HostListener, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { News } from '@model/webFeeder/news.model';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { Constants } from '@utils/constants';
import { NgxMasonryOptions } from 'ngx-masonry';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { Subject , of } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { AuthServer } from '@services/auth-server.service';
import { AgencyNewsEnum } from '@model/enum/agency-news.enum';

@Component({
  selector: 'app-modal-news',
  templateUrl: './modal-news.component.html',
  animations: [
    trigger('valueAnimation', [
      transition('void => *', [
        style({ transform: 'translateX(0) scale(0)' }),
        animate('0.2s ease-in')
      ])
    ]),
    trigger('valueListAnimation', [
      transition('* => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ]),
      transition('void => *', [
        style({
          transform: 'translateX(-100%)'
        }),
        animate('0.3s 100ms ease-in-out')
      ])
    ]),
    trigger('valueLDetailAnimation', [
      transition('* => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(100%)' }))
      ]),
      transition('void => *', [
        style({
          transform: 'translateX(100%)'
        }),
        animate('0.3s 100ms ease-in-out')
      ])
    ]),
    trigger('valueAnimationCards', [
      transition('grid => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ]),
      // TODO transition('void => grid', [
      // TODO   style({
      // TODO     transform: 'translateX(-100%)'
      // TODO   }),
      // TODO   animate('0.3s 200ms ease-in-out')
      // TODO ]),
      transition('card => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(100%)' }))
      ]),
      transition('void => card', [
        style({
          transform: 'translateX(100%)'
        }),
        animate('0.3s 200ms ease-in-out')
      ])
    ])
  ]
})
export class ModalNewsComponent implements OnInit, OnDestroy {

  @ViewChild('modalNews', { read: ViewContainerRef }) parent: ViewContainerRef;

  title = 'NOTÍCIAS';
  listNews: News[] = [];
  listNewsAux: any[] = [];
  selectedItem: any;
  page = 1;
  nPages = 0;
  listPages = [];
  cardsPage = 5;
  dateStartFilter: Date = new Date(new Date().setDate(new Date().getDate() - 3));
  dateEndFilter: Date = new Date();
  agencyFilter = AgencyNewsEnum.INVESTIMMENTOS_NOTICIA;
  textFilter = '';
  nResize = 1;
  cardsScroll = 8;
  listAgencys = [];
  isList = 1;
  loading = true;
  loadingSearch = false;
  typeNews = 1;
  timeOut: any;
  scroll: any;
  public changingValue: Subject<boolean> = new Subject();
  public myOptions: NgxMasonryOptions = {
    originLeft: true,
  };
  // transitionDuration: '1.17s',

  public intervalLasNews: any;
  public loadingGet: boolean;
  public pageTemp: number;
  public whiteLabel = this._configService.getWhiteLabel();
  filterDateRange: number;

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  // @HostListener('document:keydown', ['$event'])
  // onkeydown(event) {
  //   if (event.key == 'Escape') {
  //     if ((document.getElementsByTagName('ngb-modal-window').length == 0)) {
  //       this.close();
  //     }
  //   }
  // }

  constructor(
    public _NotificationService: NotificationsService,
    public dialogRef: MatDialogRef<ModalNewsComponent>,
    private customSnackBar: CustomSnackbarService,
    private _autoLogoutService: AutoLogoutService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _authServer: AuthServer,
    private _configService: ConfigService
  ) {
    this.filterDateRange = this._configService.getModalNewsFilterRange();
    this.listAgencys = this._configService.getNewsListAgency();
    this.cardsPage = window.innerHeight <= 800 ? 4 : window.innerHeight <= 920 ? 5 : window.innerHeight <= 1011 ? 6 :
      window.innerHeight <= 1110 ? 7 : window.innerHeight <= 1210 ? 8 : window.innerHeight <= 1310 ? 9 : 10;
  }

  ngOnInit() {
    if (this.data) {
      this.selectedItem = this.data.new;
      this.openDetails(this.selectedItem, this.data.close, this.data.origin);
    }
    this.getNews()
  }

  ngOnDestroy() {
    if (this.intervalLasNews) {
      clearInterval(this.intervalLasNews);
    }
    this.changingValue.unsubscribe();
  }

  getNews() {
    if ((this.dateStartFilter && !this.dateEndFilter) || (!this.dateStartFilter && this.dateEndFilter)) {
      this.customSnackBar.createSnack(this.parent, Constants.DATE_MSG003, Constants.ALERT_TYPE.warn);
      return;
    } else if (this.dateStartFilter > this.dateEndFilter) {
      this.customSnackBar.createSnack(this.parent, Constants.DATE_MSG001, Constants.ALERT_TYPE.warn);
      return;
    } else if (this.dateEndFilter > new Date()) {
      this.customSnackBar.createSnack(this.parent, Constants.DATE_MSG002, Constants.ALERT_TYPE.warn);
      return;
    } else if (this.dateStartFilter !== this.dateEndFilter
      && !AppUtils.validateDateRange(this.dateStartFilter, this.dateEndFilter, this.filterDateRange)) {
      const msg = Constants.DATE_MSG005.replace('{{range}}', this.filterDateRange.toString());
      this.customSnackBar.createSnack(this.parent, msg, Constants.ALERT_TYPE.warn);
      return;
    }
    this.resetResize();
    this.loadingSearch = true;
    this.listNews = [];
    this._authServer.iNews.getNewsByParameters(this.textFilter, this.agencyFilter, this.dateStartFilter, this.dateEndFilter)
      .subscribe(data => {
        if (!data || (data && data.length < 1)) {
          this._NotificationService.info('', Constants.DATE_MSG004);
          this.loadingSearch = false;
          return;
        }
        data.forEach(element => {
          if (element.agencyCode === Number(this.agencyFilter)) {
            this.listNews.push(element);
          }
        });
        AppUtils.orderObjectDesc(this.listNews, 'newsDate');
        this.listNewsAux = this.listNews;
        this.changePage(1);
        this.loadingSearch = false;
        this.loading = false;
      }, () => {
        this._NotificationService.info('', Constants.DATE_MSG004);
        this.loadingSearch = false;
        return;
      });
  }

  getPagination() {
    let i;
    this.listPages = [];
    this.nPages =
      this.listNews.length % this.cardsPage === 0
        ? Math.floor(this.listNews.length / this.cardsPage)
        : Math.floor(this.listNews.length / this.cardsPage) + 1;

    if (this.page > 2 && this.nPages - this.page > 2) {
      for (i = 1; i <= this.nPages; i++) {
        const dif = i - this.page;
        if (dif <= 2 && dif >= -2 && i > 0 && i <= this.nPages) {
          this.listPages.push(i);
        }
      }
    } else if (this.page < 3) {
      if (this.nPages > 5) {
        for (i = 1; i <= 5; i++) {
          if (i > 0 && i <= this.nPages) {
            this.listPages.push(i);
          }
        }
      } else {
        for (i = 1; i <= this.nPages; i++) {
          if (i > 0 && i <= this.nPages) {
            this.listPages.push(i);
          }
        }
      }
    } else if (this.nPages - this.page < 3) {
      for (i = this.nPages - 4; i <= this.nPages; i++) {
        if (i > 0 && i <= this.nPages) {
          this.listPages.push(i);
        }
      }
    }
    if (this.pageTemp) {
      this.page = this.pageTemp;
    }
  }

  close() {
    this.dialogRef.close();
  }

  changePage(page) {
    if (page !== 'back' && page !== 'next') {
      if (page >= 1) {
        this.pageTemp = page;
        if (page === this.nPages) {
          this.page = page;
          this.pageTemp = page;
        }
      }
    } else if (page === 'back') {
      if (this.page > 1) {
        this.page = this.page - 1;
        this.pageTemp = this.page;
      }
    } else if (page === 'next') {
      if (this.page < this.nPages) {
        this.page = this.page + 1;
        this.pageTemp = this.page;
      }
    }
    this.getPagination();
  }

  clearFilter() {
    this.changingValue.next(true);
    this.agencyFilter = AgencyNewsEnum.INVESTIMMENTOS_NOTICIA;
    this.dateStartFilter = new Date(new Date().setDate(new Date().getDate() - 3));
    this.dateEndFilter = new Date();
    if (this.textFilter !== '') {
      this.changePage(1);
      this.textFilter = '';
      this.listNews = this.listNewsAux;
    }
    this.getNews();
  }

  openDetails(event, close, origin?: string) {
    this.selectedItem = { new: event, close: close, origin: origin };
    this.isList = 0;
    this.loading = false;
  }

  openList() {
    this.selectedItem = null;
    this.listNews = this.listNews;
    this.isList = 1;
  }

  toggleType(type: number) {
    if (this.typeNews === type) {
      return;
    }
    this.page = 1;
    if (type === 1) {
      document.getElementById('col-overflow').classList.remove('col-cards-overflow');
      this.changePage(1);
    } else {
      this.resetResize();
    }
    this.typeNews = null;
    setTimeout(() => {
      this.typeNews = type;
    }, 300);
  }

  keyUpSearch(event) {
    clearTimeout(this.timeOut);
    if (event.target.value === '') {
      this.changePage(1);
      this.listNews = this.listNewsAux;
      return;
    }
    const self = this;
    this.timeOut = setTimeout(() => {
      self.filterNewsByString(event.target.value);
      this.getPagination();
    }, 500);
  }

  filterNewsByString(value) {
    const list = this.listNewsAux.filter(element => element.title.toLowerCase().includes(value.toLowerCase()));
    if (list && list.length < 1) {
      this._NotificationService.info('', Constants.DATE_MSG004);
    }
    this.listNews = list;
  }

  scrollEvent(event) {
    if (event.target.scrollTop > (event.target.scrollHeight - 650) && this.listNews.length > (this.nResize * this.cardsScroll)) {
      this.loadingGet = true;
      this.nResize++;
    }
  }

  resetResize() {
    this.nResize = 1;
  }

  changeDateIni(value) {
    if (value) {
      this.dateStartFilter = new Date(value);
    }
  }

  changeDateFim(value) {
    if (value) {
      this.dateEndFilter = new Date(value);
    }
  }

}
